import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import translations from 'services/translations/translations';
import toggleEdges from '../../../assets/toggle-edges.svg';
import toggleEdgesOff from '../../../assets/toggle-edges-off.svg';

const ToggleEdgesIcon = (): JSX.Element => {
  const { t } = useTranslation([translations.leftBar]);
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [active, setActive] = useState(true);

  const id = 'left-bar-toggle-edges-icon';

  const toggleActive = () => {
    setActive(!active);
    if (active) {
      window.TurnOnEdges();
    } else {
      window.TurnOffEdges();
    }
  };

  return (
    <>
      <img
        alt="toggleedges-icon"
        className="left-bar-icon"
        id={id}
        onClick={toggleActive}
        src={active ? toggleEdges : toggleEdgesOff}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipIsOpen}
        target={id}
        toggle={() => setTooltipIsOpen(!tooltipIsOpen)}
      >
        {t(`${translations.leftBar}:tooltips:Toggle edges`)}
      </Tooltip>
    </>
  );
};

export default ToggleEdgesIcon;
